// i18n types
export var LANGUAGES;
(function (LANGUAGES) {
    LANGUAGES["ES"] = "es";
    LANGUAGES["PT"] = "pt";
    LANGUAGES["EN"] = "en";
})(LANGUAGES || (LANGUAGES = {}));
export var AuthProvider;
(function (AuthProvider) {
    AuthProvider["FACEBOOK"] = "facebook";
    AuthProvider["GOOGLE"] = "google-oauth2";
    AuthProvider["LINKEDIn"] = "linkedin";
    AuthProvider["TWITTER"] = "twitter";
})(AuthProvider || (AuthProvider = {}));
export var TimeZonesEnum;
(function (TimeZonesEnum) {
    TimeZonesEnum["TIME_ZONE_ES_PE"] = "America/Lima";
    TimeZonesEnum["TIME_ZONE_ES_CO"] = "America/Bogota";
    TimeZonesEnum["TIME_ZONE_ES_AR"] = "America/Argentina/Buenos_Aires";
    TimeZonesEnum["TIME_ZONE_ES_MX"] = "America/Mexico_City";
    TimeZonesEnum["TIME_ZONE_ES_ES"] = "Europe/Madrid";
    TimeZonesEnum["TIME_ZONE_ES_CL"] = "America/Santiago";
    TimeZonesEnum["TIME_ZONE_PT_BR"] = "America/Sao_Paulo";
})(TimeZonesEnum || (TimeZonesEnum = {}));
//# sourceMappingURL=types.js.map